export const sizes = [
  { id: 1, name: "1 funcionário" },
  { id: 10, name: "2-9 funcionários" },
  { id: 50, name: "10-49 funcionários" },
  { id: 250, name: "50-249 funcionários" },
  { id: 500, name: "250 ou mais funcionários" },
];
